export default "__VITE_ASSET__DWeE1bN___"